import type { ReactNode } from 'react'

type StatTileProps = {
  label: string
  value: ReactNode
  hint?: ReactNode
}

/** Tuile d'indicateur : un libellé, un chiffre, une précision. Partagée par le tableau de bord et la fiche apprenant (#242). */
export function StatTile({ label, value, hint }: StatTileProps) {
  return (
    <div className="rounded-2xl border border-border bg-card p-5 shadow-sm">
      <h3 className="text-sm font-medium text-muted-foreground">{label}</h3>
      <p className="mt-2 text-3xl font-semibold">{value}</p>
      {hint != null && <p className="mt-1 text-xs text-muted-foreground">{hint}</p>}
    </div>
  )
}
